<template>
  <v-row>
    <div class="col col-12 px-8" cols="12">
      <div class="d-flex justify-space-between mb-4">
        <v-btn class="mr-2 white--text" color="blue" @click="getMatrixData" :disabled="busy">{{ busy ? 'Loading...' :
          'Refresh' }}</v-btn>
        <!-- <v-icon color="blue">mdi-export</v-icon> -->
        <v-btn icon color="blue" @click="exportToCSV" :disabled="exporting" title="Export">
          <v-icon>mdi-export</v-icon>
        </v-btn>
        <!-- <v-btn class="blue--text" color="white" @click="exportToCSV" :disabled="exporting">
          <v-icon>mdi-export</v-icon>
        </v-btn> -->
      </div>
      <div :style="{ height: gridHeight + 'px' }">
        <ag-grid-vue ref="agGrid" style="width: 100%; height: 100%" class="ag-theme-alpine" :columnDefs="columnDefs"
          :rowData="rowData" :rowDragManaged="true" @sortChanged="onSortChanged" @filterChanged="onFilterChanged"
          @dragStopped="handleDragEnd" />
      </div>


    </div>
  </v-row>
  <!-- </v-container> -->

</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { AgGridVue } from 'ag-grid-vue';
import axios from 'axios';
import { parse } from 'csv-parse';
import { stringify } from 'csv-stringify';
import { mapState } from 'vuex';
import MatrixCellLink from './MatrixCellLink.vue';
import MatrixCompanyLink from './MatrixCompanyLink.vue';
import MatrixColumnFilter from './MatrixColumnFilter.vue';
import MatrixAccountsColumnFilter from './MatrixAccountsColumnFilter.vue';

function customerValueGetter(params) {
  const { id, legal_name: name } = params.data.customer
  return { id, name }
}

function contactValueGetter(params) {
  const account_id = params.data.customer.id
  const allColumns = params.columnApi.getAllColumns();
  const col_index = allColumns.findIndex(column => column.getColId() === params.column.getColId());

  const { id, name, account_type, work_email, work_phone, personal_phone, employer_id } = params.data.pams[col_index - 1]
  return { id, name, account_type, account_id, work_email, work_phone, personal_phone, employer_id }
}

function customComparator(valueA, valueB) {
  // Check if valueA is empty (null, undefined, or empty string)
  const isValueAEmpty = !valueA || valueA.name === null || valueA.name === undefined || valueA.name === '';

  // Check if valueB is empty (null, undefined, or empty string)
  const isValueBEmpty = !valueB || valueB.name === null || valueB.name === undefined || valueB.name === '';

  // If both values are empty, consider them equal
  if (isValueAEmpty && isValueBEmpty) return 0;

  // If valueA is empty and valueB is not, sort valueA after valueB
  if (isValueAEmpty) return 1;

  // If valueB is empty and valueA is not, sort valueA before valueB
  if (isValueBEmpty) return -1;

  // Standard lexicographical comparison for non-empty values
  if (valueA.name < valueB.name) return -1;
  if (valueA.name > valueB.name) return 1;

  // If values are equal, return 0
  return 0;
}

export default {
  name: 'Matrix',
  components: {
    AgGridVue,
    matrixCellLink: MatrixCellLink,
    matrixCompanyLink: MatrixCompanyLink,
    matrixColumnFilter: MatrixColumnFilter,
    matrixAccountsColumnFilter: MatrixAccountsColumnFilter
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      rowOrder: [],
      busy: false,
      exporting: false,
      gridHeight: 400,
      columnOrder: [],
      sortFilterState: this.getSortFilterState()
    }
  },
  mounted() {
    this.getMatrixData()
    this.gridHeight = window.innerHeight - 240
    window.addEventListener('resize', () => {
      this.gridHeight = window.innerHeight - 240
    })
  },
  unmounted() {
    window.removeEventListener('resize')
  },
  beforeMount() {
    this.columnDefs = []
    this.rowData = []
  },
  methods: {
    onSortChanged(event) {
      // Preventing sort change handler invocation during
      // grid data loading.This avoids unintended side 
      // effects when the grid is still processing matrix data.
      if (!this.busy) {
        const sortState = event.columnApi.getAllColumns().map(column => ({
          colId: column.colId,
          sort: column.getSort(),
          sortIndex: column.getSortIndex()
        }));

        sortState.forEach(col => {
          // Ensure that this.sortFilterState[col.colId] is an object
          if (!this.sortFilterState[`${col.colId}`]) {
            this.sortFilterState[`${col.colId}`] = {}; // Initialize it as an empty object
          }
          this.sortFilterState[`${col.colId}`]['sort'] = col.sort || null;
        });

        // Save the sort state in the backend or local store
        this.saveGridState('sortFilterState', this.sortFilterState);
      }
    },
    onFilterChanged(event) {
      // Preventing filter change handler invocation during
      // grid data loading.This avoids unintended side 
      // effects when the grid is still processing matrix data.
      if (!this.busy) {
        const filterState = event.api.getFilterModel();
        // Save the filter state in the backend
        Object.entries(filterState).forEach(([key, value]) => {
          if (!this.sortFilterState[`${key}`]) {
            this.sortFilterState[`${key}`] = {}; // Initialize it as an empty object
          }
          this.sortFilterState[`${key}`]['filter'] = value;
        });

        // Remove 'filter' properties from sortFilterState if the key is not present in filterState
        Object.entries(this.sortFilterState).forEach(([key, entry]) => {
          // Remove 'filter' if the key is not found in filterState
          if (!filterState.hasOwnProperty(key) && entry.hasOwnProperty('filter')) {
            delete entry.filter;
          }
        });

        this.saveGridState('sortFilterState', this.sortFilterState);
      }
    },
    saveGridState(type, state) {
      // Save sort and filter state to backend
      const baseURL = this.$store.getters.baseURL;
      const userId = this.$store.state.id;
      const token = this.$store.state.userToken;

      const setSortFilterStateUrl = `${baseURL}/api/user/${userId}/matrix/update/sort-filter/`;
      axios.post(
        setSortFilterStateUrl,
        { data: this.sortFilterState },
        { headers: { 'Authorization': `Token ${token}` } }
      )
        .then(() => {
          // this.$toast.success("Successfully saved sort filter state.");
        })
        .catch(error => {
          // Handle errors for either request
          console.error(error);
          this.$toast.error("Unable to save the sort filter state.");
        });
    },
    getSortFilterState() {
      const baseURL = this.$store.getters.baseURL;
      const userId = this.$store.state.id;
      const token = this.$store.state.userToken;

      const getSortFilterStateUrl = `${baseURL}/api/user/${userId}/matrix/sort-filter/`;

      return axios.get(getSortFilterStateUrl, {
        headers: { 'Authorization': `Token ${token}` }
      })
        .then(res => {
          const sortFilterState = res.data.data;

          // Save or update the state as needed
          this.sortFilterState = sortFilterState;

          // Optionally show a success message
          // this.$toast.success("Successfully retrieved sort filter state.");

          return sortFilterState;
        })
        .catch(error => {
          console.error('Error fetching sort/filter state:', error);

          // Optionally show an error message
          this.$toast.error("Unable to get the sort filter state.");
        });
    },
    restoreGridState() {
      if (this.sortFilterState) {
        // Converting sortFilterState to ag-Grid column state format
        const columnState = Object.entries(this.sortFilterState).map(([colId, state]) => {
          return {
            colId,
            sort: state.sort || null,
            sortIndex: state.sortIndex || null
          };
        });

        // Apply the column state
        this.$refs.agGrid.gridOptions.columnApi.applyColumnState({
          state: columnState,
          defaultState: { sort: null }
        });

        // Preparing the filter model
        let filterModel = {};

        Object.keys(this.sortFilterState).forEach(key => {
          const entry = this.sortFilterState[key];

          if (entry.filter && entry.filter.selectedNames) {
            filterModel[key] = entry.filter;
          }
        });

        this.$refs.agGrid.gridOptions.api.setFilterModel(filterModel);
      }
    },
    handleDragEnd(e) {
      // This fires whenever the user finishes moving columns around
      let newRowOrder = e.api.rowModel.rowsToDisplay.map(row => row.data.customer.id)
      let newColumnOrder = e.api.columnModel.displayedColumns.map(col => col.colDef.id).filter(col => col !== undefined)

      // Maintain the new column order
      this.columnOrder = Array.isArray(newColumnOrder) ? newColumnOrder : [newColumnOrder];

      this.saveRowColumnOrder(newRowOrder, newColumnOrder)
      // this.saveColumnOrder(newColumnOrder)
    },
    saveRowColumnOrder(newRowOrder, newColumnOrder) {
      const baseURL = this.$store.getters.baseURL;
      const userId = this.$store.state.id;
      const token = this.$store.state.userToken;

      const rowOrderURL = `${baseURL}/api/user/${userId}/update/`;
      const columnOrderURL = `${baseURL}/api/user/${userId}/co_sellers/update/`;

      axios.post(rowOrderURL, {
        matrix_row_order: JSON.stringify(newRowOrder),
        matrix_column_order: JSON.stringify(newColumnOrder)
      }, {
        headers: { 'Authorization': `Token ${token}` }
      })
        .then(() => {
          // this.$toast.success("Successfully saved row order.");

          // Remove the first element that corresponds to accounts
          const updatedColumnOrder = newColumnOrder.slice(1);

          return axios.post(columnOrderURL, updatedColumnOrder, {
            headers: { 'Authorization': `Token ${token}` }
          });
        })
        .then(() => {
          // this.$toast.success("Successfully saved column order.");
        })
        .catch(error => {
          // Handle errors for either request
          console.error(error);
          this.$toast.error("Unable to save new row or column order.");
        });
    },
    sortRowsByRowOrder(rowOrder, rowData) {
      let output = []
      // For each of the rowOrder I'm sent
      // a) look at the row order 0th position (shift), 
      // b) grab the matching rowData object by filtering for customer.id and push that into output
      // c) remove the rowData object from the rowData array
      // d) filter out undefined
      // e) push the remainder of the rowData on to the end
      while (rowOrder.length) {
        let id = rowOrder.shift()
        let rowIndex = rowData.findIndex(row => row.customer.id === id)
        let row = rowIndex >= 0 ? rowData.splice(rowIndex, 1) : undefined
        if (row) {
          output = [...output, ...row]
        }
      }
      // I know this looks weird - I'm removing falsy things and this is an easy one liner
      output = output.filter(row => row ? true : false)
      return [...output, ...rowData]
    },
    clearMatrixData() {
      this.rowOrder = [];
      this.columnOrder = [];
      this.rowData = null;
      this.columnDefs = null;
    },
    getMatrixData() {
      this.busy = true;

      // Clearing the matrix data before loading
      // to avoid issues when restoring the sort 
      // and filter state.
      this.clearMatrixData();

      const url = this.$store.getters.baseURL + '/api/user/' + this.$store.state.id + '/matrix'
      this.columnDefs = []
      axios({
        method: 'get',
        url: url,
        headers: {
          'Authorization': `Token ${this.$store.state.userToken}`
        }
      })
        .then(res => {
          var headers = [
            {
              headerName: 'Accounts',
              valueGetter: customerValueGetter,
              width: 325,
              id: 0,
              colId: 0,
              resizable: true,
              rowDrag: true,
              pinned: 'left',
              lockPosition: 'left',
              cellStyle: { 'background-color': '#eeeeee' },
              cellRenderer: "matrixCompanyLink",
              sortable: true,
              unSortIcon: true,
              comparator: customComparator,
              filter: "matrixAccountsColumnFilter"
            },
          ]
          let additional_headers = []
          res.data.cosellers.forEach((element) => {
            additional_headers.push({
              resizable: true,
              headerName: element.legal_name,
              id: element.id,
              colId: element.id,
              valueGetter: contactValueGetter,
              cellRenderer: "matrixCellLink",
              sortable: true,
              unSortIcon: true,
              cellClassRules: {
                'bg-green-100': params => params.value.account_type === 'customer',
                'bg-yellow-100': params => params.value.account_type === 'prospect',
                'bg-red-100': params => params.value.account_type === 'unknown'
              },
              comparator: customComparator,
              filter: "matrixColumnFilter"
            })
          })

          this.rowOrder = JSON.parse(res.data.matrix_row_order)
          this.columnOrder = res.data.matrix_column_order
          this.rowData = this.sortRowsByRowOrder(this.rowOrder, res.data.rows)
          this.columnDefs = [...headers, ...additional_headers]
          this.$store.commit('setMatrixReloadNeeded', false)
          this.busy = false
        })
        .then(() => {
          // Restore the last saved sort/filter
          // state to ensure the matrix state 
          // is persisted across sessions.
          this.restoreGridState();
        })
        .catch(err => {
          console.error(err)
          this.busy = false
        })
    },
    processCSV(csvData) {
      this.exporting = true;
      const newColumns = ['', 'Email', 'Work Phone', 'Personal Phone', 'Flag'];
      const excludedColumns = ['Accounts'];

      parse(csvData, { columns: true, trim: true }, (err, records) => {
        if (err) {
          console.error('Error parsing CSV:', err);
          return;
        }

        const delimiter = '|';
        const headers = Object.keys(records[0]);
        const result = [];
        const maxSplits = {};  // track maximum number of splits per column

        // Determine maximum number of splits required for each column
        records.forEach((record) => {
          headers.forEach((header) => {
            if (!excludedColumns.includes(header) &&
              record[header] && record[header].includes(delimiter)) {
              const splitData = record[header].split(delimiter);
              if (!maxSplits[header] || splitData.length > maxSplits[header]) {
                maxSplits[header] = splitData.length;
              }
            }
          });
        });

        // Create new columns based on maximum splits
        records.forEach((record) => {
          const newRecord = {};
          headers.forEach((header) => {
            if (excludedColumns.includes(header)) {
              // Copy columns that are excluded from splitting as-is
              newRecord[header] = record[header];
            } else {
              const splitData = record[header].split(delimiter);
              splitData.forEach((data, index) => {
                newRecord[`${header}${newColumns[index] ? '_' + newColumns[index] : ''}`] = data;
              });
              // Filling in missing columns with empty strings
              for (let i = splitData.length; i < maxSplits[header]; i++) {
                newRecord[`${header}${newColumns[i] ? '_' + newColumns[i] : ''}`] = '';
              }
            }
          });
          result.push(newRecord);
        });

        stringify(result, { header: true }, (err, output) => {
          if (err) {
            console.error('Error stringifying CSV:', err);
            return;
          }

          const blob = new Blob([output], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'export.csv');
          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
        this.exporting = false;
      });
    },
    exportToCSV() {
      if (this.$refs.agGrid && this.$refs.agGrid.gridOptions && this.$refs.agGrid.gridOptions.api) {
        const csvData = this.$refs.agGrid.gridOptions.api.getDataAsCsv({
          columnKeys: this.columnOrder.map(String),
          processCellCallback: (params) => {
            const value = params.value;

            if (typeof value === 'object' && value !== null) {
              if (value.name) {
                if (value.work_email || value.work_phone || value.personal_phone) {
                  return value.name + "|" + value.work_email + "|" + value.work_phone + "|" + value.personal_phone + "|" + value.account_type;
                }
                return value.name;
              }
              return "";
            }
            return "";
          },
        });
        this.processCSV(csvData);
      } else {
        console.error("Ag-Grid is not fully initialized yet.");
      }
    },
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'updateAccountType') {
        const { userId, accountId, employerId, newAccountType } = mutation.payload;

        // Send request to update the status
        this.busy = true;
        const url = this.$store.getters.baseURL + '/api/user/' + this.$store.state.id + '/matrix/update/account-type/';
        const updateAccountRequestBody = {
          user_id: userId,
          customer_id: accountId,
          account_type: newAccountType
        };
        axios({
          method: 'post',
          url: url,
          headers: {
            'Authorization': `Token ${this.$store.state.userToken}`,
            'Content-Type': 'application/json'
          },
          data: updateAccountRequestBody
        })
          .then(res => {
            const gridOptions = this.$refs.agGrid.gridOptions;
            const allColumns = gridOptions.columnApi.getAllColumns();

            gridOptions.api.forEachNode((rowNode) => {
              allColumns.forEach(col => {
                const colId = col.getId();
                const cellValue = gridOptions.api.getValue(colId, rowNode);
                const rowData = rowNode.data;
                const isCorrectCell = cellValue && cellValue.id === userId && rowData.customer.id === accountId && colId == employerId;

                if (isCorrectCell) {
                  // Find the specific pam to update
                  const pamToUpdate = rowData.pams.find(pam => pam.id === userId);
                  if (pamToUpdate) {
                    pamToUpdate.account_type = newAccountType;
                    gridOptions.api.applyTransaction({ update: [rowData] });
                  }
                }
              });
            });
          })
          .catch(err => {
            console.error('Error:', err);
          })
          .finally(() => {
            this.busy = false;
          });
      }
    });
  },
  computed: mapState(['matrixReloadNeeded']),
  watch: {
    matrixReloadNeeded(newValue, oldValue) {
      if (newValue) {
        this.getMatrixData()
      }
    }
  }
}
</script>